import { Component, EventEmitter, Output, Input } from "@angular/core";
import { WizardSubstep } from "../../../common/wizard/wizard-subtep.interface";
import moment from "moment";

@Component({
  selector: "icn-autopilot-rule-wizard-done",
  templateUrl: "./done.html",
})
export class AutopilotRuleWizardDoneComponent implements WizardSubstep {
  canGoNext(): boolean {
    return false;
  }
}
